import { MeasurementType } from 'types/order.types'
import { OrderCommodity } from 'types/orderCommodity.types'
import { isNotNullOrUndefined, isNullOrUndefined } from './values.utils'

export const getCommoditySizeString = (
    commodity: Partial<Pick<OrderCommodity, 'length' | 'width' | 'height'>>,
    opts: {
        measurementType?: MeasurementType | null
    }
): string => {
    if (
        isNullOrUndefined(commodity.length) ||
        isNullOrUndefined(commodity.width) ||
        isNullOrUndefined(commodity.height)
    ) {
        return ''
    }

    return [
        [commodity.length ?? 0, opts.measurementType]
            .filter(isNotNullOrUndefined)
            .join(''),
        [commodity.width ?? 0, opts.measurementType]
            .filter(isNotNullOrUndefined)
            .join(''),
        [commodity.height ?? 0, opts.measurementType]
            .filter(isNotNullOrUndefined)
            .join(''),
    ]
        .filter(Boolean)
        .join(' x ')
}
